import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Menu, MenuItem, Button, IconButton, Divider, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, FormHelperText, Grid, InputLabel, Select, InputBase, Paper, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from "@material-ui/icons/Clear";
import WatchOutlinedIcon from '@mui/icons-material/WatchOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import InfoIcon from '@mui/icons-material/Info';
import holdIcon from "../../../../assests/images/pause.png";
import ContentWrapper from "../../../../common/components/contentWrapper";
import "../../dashboard/style/watchRequestList.css";
import dashboardApi from "../actions/dashboardaapi";
import { SpinnerRoundFilled } from "spinners-react";
import Loader from "react-loader-spinner";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { connect } from "react-redux";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { bindActionCreators } from "redux";
import { brandList } from "../actions/dashboardAction";
import { showSuccessToast, showErrorToast } from "../../../../common/components/Helper/Utils";

const CREATE_ROUTE = "/watch-request";
const DETAILS_ROUTE = (id) => `/watchrequest/${id}`;

const PAGE_LIMIT = 25;
const ACTION_OPTIONS = [
    { label: "Close Request", icon: <CloseIcon /> },
    { label: "Hold Request", icon: <img src={holdIcon} alt="" width={18} height={18} style={{ marginRight: 12, opacity: 0.6 }} /> },
    { label: "Delete Request", icon: <DeleteIcon /> },
];

const CustomInput = ({ openCalendar, value, label, placeholder }) => (
    <TextField
        label={label}
        placeholder={placeholder}
        variant="outlined"
        fullWidth
        value={value || ""}
        onClick={openCalendar}
        onFocus={openCalendar}
        InputLabelProps={{ shrink: true }}
        InputProps={{ readOnly: true, style: { height: 45, color: "black" } }}
    />
);

const CustomFooter = ({ setInvoiceDateRange }) => {
    const handleDateRangeSelection = (months) => {
        const endDate = new DateObject();
        const startDate = new DateObject().subtract(months, "months");
        setInvoiceDateRange([startDate, endDate]);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", padding: "15px", gap: "8px" }}>
            <button type="button" id="clearBtn" onClick={() => handleDateRangeSelection(1)}>Last 1 Month</button>
            <button type="button" id="clearBtn" onClick={() => handleDateRangeSelection(3)}>Last 3 Months</button>
            <button type="button" id="clearBtn" onClick={() => handleDateRangeSelection(6)}>Last 6 Months</button>
        </div>
    );
};

const ACTION_DIALOGS = {
    "Close Request": {
        title: "Close Request",
        verb: "Close",
        status: "Closed",
        commentKey: "closed_comments",
        commentLabel: "Please enter the reason for close request",
        requiredMessage: "Please enter the reason for close request.",
        info: "The request will be moved to closed status.",
    },
    "Hold Request": {
        title: "Hold Request",
        verb: "Hold",
        suffix: " on hold",
        status: "Hold",
        commentKey: "hold_comments",
        commentLabel: "Please enter the reason for hold request",
        requiredMessage: "Please enter the reason for hold request.",
        info: "The request status will change to Hold.",
    },
};

const STATUS_OPTIONS = ["Open", "Hold", "Closed"];
const SORT_OPTIONS = [
    { value: "newest", label: "Newest first" },
    { value: "oldest", label: "Oldest first" },
];

const clean = (v) => (v && v !== "ALL" ? v : null);
const WATCH_TYPES = ["standard_watch", "misc_watch"];

const toRange = (r) =>
    Array.isArray(r) && r.length === 2 ? { from: toApiDate(r[0].toDate()), to: toApiDate(r[1].toDate()) } : null;

const hasValue = (v) => v !== undefined && v !== null && String(v).trim() !== "";
const COLUMNS = [
    { key: "item", label: "Request / Inventory Item", width: "2.4fr", always: true },
    { key: "brand", label: "Brand & Model", width: "1.5fr", has: (r) => hasValue(r.brand) || hasValue(r.modelNumber) },
    { key: "requestedBy", label: "Requested By", width: "1.8fr", has: (r) => hasValue(r.requestedBy) },
    { key: "createdDate", label: "Created Date", width: "1.3fr", sortKey: "createdon", has: (r) => hasValue(r.createdDate) },
    { key: "targetDate", label: "Target Date", width: "1.3fr", sortKey: "targeton", has: (r) => hasValue(r.targetDate) },
    { key: "budget", label: "Budget", width: "1.8fr", has: (r) => hasValue(r.budget) },
    { key: "status", label: "Status", width: "1fr", align: "center", has: (r) => hasValue(r.status) },
    { key: "actions", label: "Actions", width: "100px", raw: true, align: "center", always: true },
];
const statusClass = (status) => {
    const s = String(status || "").toLowerCase();
    if (s.includes("open")) return "open";
    if (s.includes("hold")) return "hold";
    if (s.includes("clos")) return "closed";
    return "other";
};

const getUserId = () => {
    try {
        const user = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
        return pick(user, ["userid", "user_id", "userId", "id"]);
    } catch (e) {
        return "";
    }
};

const getViewStrip = (r) =>
    [
        { label: "Preferred Budget", value: r.budget, gold: true },
        { label: "Request From", value: r.request_contactname },
        { label: "Target Date", value: r.targetDate },
        { label: "Created", value: r.createdDate },
    ].filter((f) => hasValue(f.value));

const getViewFields = (r) =>
    [
        { label: "Product Title", value: r.inventory_title !== r.title ? r.inventory_title : "" },
        { label: "Case Material", value: r.caseMaterial },
        { label: "Case Size", value: r.caseSize },
        { label: "Dial Color", value: r.dial_color },
        { label: "Band Size", value: r.band_size },
        { label: "Number of Links / Screws", value: r.number_of_links },
        { label: "Band Material", value: r.band_material },
        { label: "Requested On", value: r.requestedOn },
        { label: "Request Notes", value: r.request_notes },
        { label: "Description", value: r.description },
    ].filter((f) => hasValue(f.value));

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 230,
        color: "rgb(55, 65, 81)",
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
        "& .MuiMenu-list": { padding: "4px 0" },
        "& .MuiMenuItem-root": {
            padding: "10px 18px",
            "& .MuiSvgIcon-root": {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            "&:active": {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            },
        },
    },
}));

const getAccountId = (props) => {
    if (props && props.accountid) return props.accountid;
    try {
        const user = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
        return pick(user, ["accountid", "account_id", "accountId"]);
    } catch (e) {
        return "";
    }
};

const pick = (obj, keys) => {
    for (const k of keys) {
        if (obj && obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
    }
    return "";
};

const formatDate = (v, utc = false) => {
    if (!v) return "";
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    const dd = String(utc ? d.getUTCDate() : d.getDate()).padStart(2, "0");
    const mm = String((utc ? d.getUTCMonth() : d.getMonth()) + 1).padStart(2, "0");
    const yyyy = utc ? d.getUTCFullYear() : d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
};

const toApiDate = (d) =>
    `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getDate()).padStart(2, "0")}`;

const getDefaultInterval = () => {
    const to = new Date();
    const from = new Date();
    from.setDate(to.getDate() - 30);
    return { from: toApiDate(from), to: toApiDate(to) };
};

const extractList = (json) => {
    const list = Array.isArray(json)
        ? json
        : json?.data?.rows || json?.data || json?.requests || json?.result || json?.rows || [];
    return Array.isArray(list) ? list : [];
};

const extractTotal = (json) => {
    const t = json?.total ?? json?.totalCount ?? json?.total_count ?? json?.count ?? json?.data?.total;
    return t !== undefined && t !== null && !isNaN(Number(t)) ? Number(t) : null;
};

const formatBudget = (r) => {
    const direct = pick(r, ["budget", "preferred_budget", "preferredBudget"]);
    if (direct) return String(direct);
    const min = pick(r, ["target_price_min", "budget_min", "budgetMin", "min_budget", "minBudget"]);
    const max = pick(r, ["target_price_max", "budget_max", "budgetMax", "max_budget", "maxBudget"]);
    const fmt = (n) =>
        isNaN(Number(n))
            ? String(n)
            : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    if (min !== "" && max !== "") return `${fmt(min)} - ${fmt(max)}`;
    if (min !== "" || max !== "") return fmt(min !== "" ? min : max);
    return "";
};

const mapRequest = (r = {}, index = 0) => ({
    id: String(pick(r, ["id", "request_id", "requestId", "requestid"]) || index),
    requestid: pick(r, ["requestid", "request_id", "requestId", "id"]),
    requestno: pick(r, ["requestno", "request_no", "requestNo"]),
    title:
        pick(r, ["title", "name", "product_name", "productName", "inventory_title", "model_name"]) ||
        [pick(r, ["brand", "brand_name", "brandName"]), pick(r, ["model_number", "modelNumber", "model", "model_name"])]
            .filter(Boolean)
            .join(" "),
    status: pick(r, ["status"]),
    brand: pick(r, ["brand", "brand_name", "brandName"]),
    modelNumber: pick(r, ["model_number", "modelNumber", "model_name"]),
    type: pick(r, ["inventory_type", "type"]),
    inventory_title: pick(r, ["inventory_title", "product_title"]),
    model_name: pick(r, ["model_name"]),
    dial_color: pick(r, ["dial_color", "dialColor"]),
    band_size: pick(r, ["band_size"]),
    number_of_links: pick(r, ["number_of_links"]),
    description: pick(r, ["description"]),
    band_material: pick(r, ["band_material"]),
    budget: formatBudget(r),
    caseMaterial: pick(r, ["case_material", "caseMaterial"]),
    caseSize: pick(r, ["case_size", "caseSize"]),
    requestedBy: [
        pick(r, ["request_contact_businessname"]),
        pick(r, ["request_contactname"]),
    ].filter(Boolean).join(" / "),
    request_notes: pick(r, ["request_notes", "requestNotes"]),
    hold_comments: pick(r, ["hold_comments"]),
    closed_comments: pick(r, ["closed_comments"]),
    createdDate: formatDate(pick(r, ["createdon", "created_at", "createdAt", "created_date", "createdDate"])),
    createdRaw: pick(r, ["createdon", "created_at", "createdAt", "created_date", "createdDate"]),
    requestedOn: formatDate(pick(r, ["requested_on", "requestedOn"]), true),
    targetDate: formatDate(pick(r, ["target_date", "targetDate"]), true),
    targetRaw: pick(r, ["target_date", "targetDate"]),
    requested_on: pick(r, ["requested_on", "requestedOn"]),
    target_date: pick(r, ["target_date", "targetDate"]),
    updatedRaw: pick(r, ["updatedon", "updated_at", "updatedAt", "updated_date", "updatedDate", "modifiedon"]),
});
const WatchRequestList = (props) => {
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const [contactName, setContactName] = useState("");
    const [appliedContactName, setAppliedContactName] = useState("");
    const [createdRange, setCreatedRange] = useState([]);
    const [targetRange, setTargetRange] = useState([]);
    const [createdApplied, setCreatedApplied] = useState(null);
    const [targetApplied, setTargetApplied] = useState(null);
    const [typeFilter, setTypeFilter] = useState("ALL");
    const [statusFilter, setStatusFilter] = useState("Open");
    const [sortOrder, setSortOrder] = useState("newest");
    const [dateInterval] = useState(getDefaultInterval);
    const [brandFilter, setBrandFilter] = useState("ALL");
    const brandInfo = props.brandInfo?.data || [];
    const [requests, setRequests] = useState([]);
    const [total, setTotal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState("");
    const [reloadKey, setReloadKey] = useState(0);
    const [pageNo, setPageNo] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [counts, setCounts] = useState({});
    const [sort, setSort] = useState({ sortBy: "createdon", sortOrder: "desc" });
    const [menu, setMenu] = useState({ anchorEl: null, request: null });
    const [expanded, setExpanded] = useState({});
    const [actionDialog, setActionDialog] = useState({ open: false, type: "", request: null });
    const [actionComment, setActionComment] = useState("");
    const [actionError, setActionError] = useState("");
    const [deleteRequest, setDeleteRequest] = useState(null);
    const sentinelRef = useRef(null);
    const loadMoreRef = useRef(() => { });
    const reqSeq = useRef(0);
    const createdPickerRef = useRef(null);
    const targetPickerRef = useRef(null);

    const fetchPage = async (page) => {
        const accountid = getAccountId(props);
        if (!accountid) {
            setRequests([]);
            setError("Account details not found. Please log in again.");
            setLoading(false);
            return;
        }
        const seq = ++reqSeq.current;
        if (page === 1) {
            setLoading(true);
            setError("");
        } else {
            setLoadingMore(true);
        }
        const brandName = clean(brandFilter)
            ? brandInfo.find((b) => b.brandid === brandFilter)?.brandname || null
            : null;
        const payload = {
            accountid,
            search: appliedSearch.trim() || null,
            type: WATCH_TYPES.includes(typeFilter) ? typeFilter : null,
            inventory_type: clean(typeFilter) && !WATCH_TYPES.includes(typeFilter) ? typeFilter : null,
            brand_name: brandName,
            status: clean(statusFilter),
            contact_name: appliedContactName.trim() || null,
            sortBy: sort.sortBy,          // ← add
            sortOrder: sort.sortOrder,
            pageNo: page,
            limit: PAGE_LIMIT,
        };
        if (createdApplied) payload.requestinfodateinterval = createdApplied;
        if (targetApplied) payload.targetdateinterval = targetApplied;
        try {
            const json = await new Promise((resolve, reject) => {
                dashboardApi.requestList(payload, (err, data) => (err ? reject(err) : resolve(data)));
            });
            if (json && json.success === 0) throw new Error(json.message || "Failed to load requests.");
            const mapped = extractList(json).map(mapRequest);
            if (seq !== reqSeq.current) return;
            setRequests((prev) => (page === 1 ? mapped : [...prev, ...mapped]));
            if (page === 1) setCounts(json || {});
            setPageNo(page);
            setHasMore(mapped.length >= PAGE_LIMIT);
        } catch (e) {
            if (seq !== reqSeq.current) return;
            if (page === 1) {
                setRequests([]);
                setTotal(null);
                setError(e?.response?.data?.message || e?.message || "Something went wrong while loading requests.");
            }
            setHasMore(false);
        } finally {
            if (seq === reqSeq.current) {
                setLoading(false);
                setLoadingMore(false);
            }
        }
    };

    useEffect(() => {
        setExpanded({});
    }, [
        typeFilter,
        brandFilter,
        statusFilter,
        createdRange,
        targetRange,
        createdApplied,
        targetApplied,
        appliedSearch,
        appliedContactName,
    ]);

    useEffect(() => {
        fetchPage(1);
        return () => {
            reqSeq.current += 1;
        };
    }, [reloadKey, props.accountid, appliedSearch, appliedContactName, typeFilter, brandFilter, statusFilter, createdApplied, targetApplied, sort]);

    // Scroll pagination
    loadMoreRef.current = () => {
        if (!loading && !loadingMore && hasMore && !error) fetchPage(pageNo + 1);
    };

    useEffect(() => {
        props.brandList();
    }, []);

    useEffect(() => {
        const el = sentinelRef.current;
        if (!el || typeof IntersectionObserver === "undefined") return undefined;
        const io = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) loadMoreRef.current();
            },
            { rootMargin: "200px" }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [hasMore, requests.length, loading]);

    const openMenu = (e, request) => setMenu({ anchorEl: e.currentTarget, request });
    const closeMenu = () => setMenu({ anchorEl: null, request: null });

    const toggleExpand = (id) => setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    const getExpandFields = (r) =>
        [
            { label: "Type", value: r.type || r.watchType },
            { label: "Product Title", value: r.inventory_title !== r.title ? r.inventory_title : "" },
            { label: "Case Material", value: r.caseMaterial },
            { label: "Case Size", value: r.caseSize },
            { label: "Dial Color", value: r.dial_color },
            { label: "Band Size", value: r.band_size },
            { label: "Number of Links / Screws", value: r.number_of_links },
            { label: "Band Material", value: r.band_material },
            { label: "Requested On", value: r.requestedOn },
            { label: "Request Notes", value: r.request_notes },
            { label: "Description", value: r.description },
            { label: "Hold Reason", value: statusClass(r.status) === "hold" ? r.hold_comments : "" },
            { label: "Closed Reason", value: statusClass(r.status) === "closed" ? r.closed_comments : "" },
        ].filter((f) => hasValue(f.value));

    const onCreatedChange = (v) => {
        setCreatedRange(v);
        if (v.length === 2) {
            setCreatedApplied(toRange(v));
            createdPickerRef.current?.closeCalendar();
        } else if (v.length === 0) {
            setCreatedApplied(null);
            createdPickerRef.current?.closeCalendar();
        }
    };

    const onTargetChange = (v) => {
        setTargetRange(v);
        if (v.length === 2) {
            setTargetApplied(toRange(v));
            targetPickerRef.current?.closeCalendar();
        } else if (v.length === 0) {
            setTargetApplied(null);
            targetPickerRef.current?.closeCalendar();
        }
    };

    const handleSort = (sortKey) =>
        setSort((prev) =>
            prev.sortBy === sortKey
                ? { sortBy: sortKey, sortOrder: prev.sortOrder === "desc" ? "asc" : "desc" }
                : { sortBy: sortKey, sortOrder: "desc" }
        );

    const applySearchFilters = () => {
        const trimmedSearch = search.trim();
        const trimmedContactName = contactName.trim();
        setAppliedSearch(trimmedSearch);
        setAppliedContactName(trimmedContactName);
    };

    const formatLongDate = (v) => {
        if (!v) return "";
        const d = new Date(v);
        return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    };

    const clearContactName = () => {
        setContactName("");
        setAppliedContactName("");
    };

    const clearSearch = () => {
        setSearch("");
        setAppliedSearch("");
    };

    const handleFilterKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            applySearchFilters();
        }
    };
    const handleAction = (type) => {
        const request = menu.request;
        closeMenu();
        if (!request) return;
        if (ACTION_DIALOGS[type]) {
            setActionDialog({ open: true, type, request });
            setActionComment("");
            setActionError("");
        }
        if (type === "Delete Request") {
            setDeleteRequest(request);
            return;
        }
    };

    const closeActionDialog = () => setActionDialog((d) => ({ ...d, open: false }));

    const submitAction = () => {
        const cfg = ACTION_DIALOGS[actionDialog.type];
        if (!cfg) return;
        if (!actionComment.trim()) {
            setActionError(cfg.requiredMessage);
            return;
        }
        const payload = {
            requestid: Number(actionDialog.request.id),
            status: cfg.status,
            [cfg.commentKey]: actionComment.trim(),
            updatedby: getUserId(),
        };
        dashboardApi.updateRequestStatus(payload, (err, data) => {
            if (err || data?.success === 0) {
                setActionError(err?.response?.data?.message || data?.message || "Something went wrong. Please try again.");
                return;
            }
            closeActionDialog();
            showSuccessToast(data?.message || "Request status updated successfully.");
            setReloadKey((k) => k + 1);
            setReloadKey((k) => k + 1);
        });
    };

    const submitDelete = () => {
        const payload = {
            requestid: Number(deleteRequest.id),
            updatedby: getUserId(),
        };
        dashboardApi.deleteRequest(payload, (err, data) => {
            if (err || data?.success === 0) {
                showErrorToast(err?.response?.data?.message || data?.message || "Something went wrong. Please try again.");
                return;
            }
            setDeleteRequest(null);
            setReloadKey((k) => k + 1);
        });
    };

    const stats = useMemo(
        () => ({
            total: requests.length,
            open: requests.filter((r) => r.status === "open" || r.status === "in_review").length,
            matched: requests.filter((r) => r.status === "matched").length,
        }),
        [requests]
    );

    // const filtered = useMemo(() => {
    //     const time = (r) => {
    //         const t = new Date(r.createdRaw).getTime();
    //         return isNaN(t) ? 0 : t;
    //     };
    //     const list = [...requests];
    //     list.sort((a, b) => (sortOrder === "oldest" ? time(a) - time(b) : time(b) - time(a)));
    //     return list;
    // }, [requests, sortOrder]);

    const filtered = requests;

    const visibleColumns = useMemo(
        () => requests.length === 0 ? COLUMNS : COLUMNS.filter((c) => c.always || requests.some((r) => c.has(r))),
        [requests]
    );
    const gridTemplate = visibleColumns.map((c) => (c.raw ? c.width : `minmax(0, ${c.width})`)).join(" ");

    const goCreate = () => {
        if (props.onCreate) props.onCreate();
        else if (props.history) props.history.push(CREATE_ROUTE);
    };

    const goDetails = (r) => {
        if (props.onView) props.onView(r);
        else if (props.history) props.history.push(DETAILS_ROUTE(r.id));
    };

    const renderCell = (key, r) => {
        const dash = <span className="wrl-t-text">-</span>;
        switch (key) {
            case "item":
                return (
                    <div className="wrl-t-item">
                        {/* <div className="wrl-t-thumb">
                            {r.image ? (
                                <img src={r.image} alt={r.title} />
                            ) : (
                                <WatchOutlinedIcon className="wrl-card__thumb-icon" />
                            )}
                        </div> */}
                        <div className="wrl-t-item__info">
                            <p className="wrl-t-item__name" title={r.title || ""}>{r.title || "-"}</p>
                            <div className="wrl-t-item__idrow">
                                <button
                                    type="button"
                                    className="wrl-t-idlink"
                                    aria-expanded={Boolean(expanded[r.id])}
                                    title={expanded[r.id] ? "Hide details" : "Show details"}
                                    onClick={() => toggleExpand(r.id)}
                                >
                                    {r.requestno || "-"}
                                    {expanded[r.id] ? (
                                        <ExpandLessIcon fontSize="inherit" />
                                    ) : (
                                        <ExpandMoreIcon fontSize="inherit" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            case "brand":
                return r.brand || r.modelNumber ? (
                    <div>
                        {r.brand && <p className="wrl-t-brand">{r.brand}</p>}
                        {r.modelNumber && <p className="wrl-t-model">{r.modelNumber}</p>}
                    </div>
                ) : (
                    dash
                );
            case "type":
                return r.watchType ? <span className="wrl-t-pill">{r.watchType}</span> : dash;
            case "requestedBy":
                return r.requestedBy ? <span className="wrl-t-text">{r.requestedBy}</span> : dash;
            case "createdDate":
                return r.createdDate ? <span className="wrl-t-date">{r.createdDate}</span> : dash;
            case "targetDate":
                return r.targetRaw ? (
                    <span className="wrl-t-date">
                        {formatDate(r.targetRaw, true)}
                    </span>
                ) : (
                    dash
                );
            case "budget":
                return r.budget ? <span className="wrl-t-date">{r.budget}</span> : dash;
            case "status":
                return r.status ? (
                    <span className={`wrl-t-status wrl-t-status--${statusClass(r.status)}`}>{r.status}</span>
                ) : (
                    dash
                );
            case "actions": {
                const menuOpenForThis = Boolean(menu.anchorEl) && menu.request && menu.request.id === r.id;
                return (
                    <div className="wrl-card__action">
                        <Button
                            type="button"
                            className="wrl-btn wrl-btn--outline"
                            onClick={(e) => openMenu(e, r)}
                            style={{
                                color: "#1976d2",
                                textDecoration: "none",
                                textTransform: "none",
                                minWidth: "95px",
                            }}
                        >
                            Actions
                            {menuOpenForThis ? (
                                <ExpandLessIcon fontSize="small" />
                            ) : (
                                <ExpandMoreIcon fontSize="small" />
                            )}
                        </Button>
                    </div>
                );
            }
            default:
                return null;
        }
    };

    const actionCfg = ACTION_DIALOGS[actionDialog.type];
    const actionReq = actionDialog.request;

    const contentView = (
        <div className="wrl-page">
            <Container maxWidth={false} className="wrl-container">
                {/* Heading */}
                <div className="wrl-topbar">
                    <div>
                        <p className="wrl-title">MY Requests List</p>
                        <p className="wrl-subtitle">Review the watches and products requested.</p>
                    </div>
                    <button type="button" className="wrl-btn wrl-btn--primary wrl-btn--add" onClick={goCreate}>
                        <AddIcon fontSize="small" />
                        Create Request
                    </button>
                </div>

                <Grid container spacing={2} style={{ marginBottom: 16 }}>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" className="formControl" fullWidth>
                            <InputLabel className="font-14">Type</InputLabel>
                            <Select style={{ color: "black", height: "45px" }} label="Type" value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
                                <MenuItem value="ALL">All</MenuItem>
                                <MenuItem value="standard_watch">Standard Watch</MenuItem>
                                <MenuItem value="misc_watch">Misc Watch</MenuItem>
                                <MenuItem value="Watch Related Accessories">Watch Related Accessories</MenuItem>
                                <MenuItem value="Apparel">Apparel</MenuItem>
                                <MenuItem value="Watch Parts">Watch Parts</MenuItem>
                                <MenuItem value="Jewelry">Jewelry</MenuItem>
                                <MenuItem value="Stones">Stones</MenuItem>
                                <MenuItem value="Hand Bags">Hand Bags</MenuItem>
                                <MenuItem value="Wallets">Wallets</MenuItem>
                                <MenuItem value="Bag Related Accessories">Bag Related Accessories</MenuItem>
                                <MenuItem value="Service Watches">Service Watches</MenuItem>
                                <MenuItem value="Others">Others</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" className="formControl" fullWidth>
                            <InputLabel className="font-14">Brand</InputLabel>
                            <Select style={{ color: "black", height: "45px" }} label="Brand" value={brandFilter} onChange={(e) => setBrandFilter(e.target.value)}>
                                <MenuItem value="ALL">All</MenuItem>
                                {brandInfo.map((row) => (
                                    <MenuItem key={row.brandid} value={row.brandid}>{row.brandname}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl variant="outlined" className="formControl" fullWidth>
                            <InputLabel className="font-14">Status</InputLabel>
                            <Select style={{ color: "black", height: "45px" }} label="Status" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                                <MenuItem value="ALL">All</MenuItem>
                                {STATUS_OPTIONS.map((s) => (
                                    <MenuItem key={s} value={s}>{s}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <DatePicker
                            ref={createdPickerRef}
                            range
                            render={<CustomInput label="Created on" placeholder="from YYYY/MM/DD to YYYY/MM/DD" />}
                            value={createdRange}
                            containerStyle={{ display: "block" }}
                            onChange={onCreatedChange}
                            rangeHover
                            dateSeparator=" to "
                            placeholder="from YYYY/MM/DD to YYYY/MM/DD"
                            plugins={[<DatePanel position="right" />, <CustomFooter setInvoiceDateRange={onCreatedChange} />]}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <DatePicker
                            ref={targetPickerRef}
                            range
                            render={<CustomInput label="Target Date" placeholder="from YYYY/MM/DD to YYYY/MM/DD" />}
                            value={targetRange}
                            containerStyle={{ display: "block" }}
                            onChange={onTargetChange}
                            rangeHover
                            dateSeparator=" to "
                            placeholder="from YYYY/MM/DD to YYYY/MM/DD"
                            plugins={[<DatePanel position="right" />, <CustomFooter setInvoiceDateRange={onTargetChange} />]}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <Paper style={{ height: "45px", display: "flex", alignItems: "center" }}>
                            <InputBase
                                fullWidth
                                sx={{ ml: 3, flex: 1 }}
                                placeholder="Search by Name / Business Name"
                                value={contactName}
                                onChange={(e) => setContactName(e.target.value)}
                                onKeyDown={handleFilterKeyDown}
                            />
                            {contactName && (
                                <IconButton size="small" onClick={clearContactName} aria-label="clear contact name">
                                    <ClearIcon fontSize="small" style={{ color: "#1976d2" }} />
                                </IconButton>
                            )}
                            <IconButton
                                onClick={applySearchFilters}
                                aria-label="search"
                                style={{ background: "#D1A05C", color: "#fff", width: 34, height: 34, margin: "0 6px" }}
                            >
                                <SearchIcon fontSize="small" />
                            </IconButton>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Paper style={{ height: "45px", display: "flex", alignItems: "center" }}>
                            <InputBase
                                fullWidth
                                sx={{ ml: 3, flex: 1 }}
                                placeholder="Search Model No / Product Title"
                                value={search}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    setSearch(v);
                                    if (v === "") setAppliedSearch("");
                                }}
                                onKeyDown={handleFilterKeyDown}
                            />
                            {search && (
                                <IconButton size="small" onClick={clearSearch} aria-label="clear search">
                                    <ClearIcon fontSize="small" style={{ color: "#1976d2" }} />
                                </IconButton>
                            )}
                            <IconButton
                                onClick={applySearchFilters}
                                aria-label="search"
                                style={{ background: "#D1A05C", color: "#fff", width: 34, height: 34, margin: "0 6px" }}
                            >
                                <SearchIcon fontSize="small" />
                            </IconButton>
                        </Paper>
                    </Grid>
                </Grid>

                {(() => {
                    const countKey = { Open: "open_count", Hold: "hold_count", Closed: "closed_count" }[statusFilter] || "total_count";
                    const countLabel = {
                        Open: "# of Open Request",
                        Hold: "# of Hold Request",
                        Closed: "# of Closed Request",
                    }[statusFilter] || "# of Requests";
                    const shown = counts[countKey] ?? total;
                    return shown !== null && shown !== undefined ? (
                        <p style={{ fontWeight: 640, fontSize: "20px", marginBottom: "20px" }}>
                            {countLabel} : {shown}
                        </p>
                    ) : null;
                })()}

                {loading ? (
                    <div className="d-spinner">
                        <SpinnerRoundFilled
                            size={51}
                            thickness={125}
                            speed={80}
                            color="rgba(57, 107, 172, 1)"
                            className="spp"
                            enabled={loading}
                        />
                    </div>
                ) : (
                    <>
                        <div className="wrl-t">
                            <div className="wrl-t-inner">
                                <div className="wrl-t-head" style={{ gridTemplateColumns: gridTemplate }}>
                                    {visibleColumns.map((c) => (
                                        <div
                                            key={c.key}
                                            onClick={c.sortKey ? () => handleSort(c.sortKey) : undefined}
                                            style={{
                                                ...(c.sortKey ? { cursor: "pointer", display: "flex", alignItems: "center", gap: 4, userSelect: "none" } : {}),
                                                ...(c.align ? { display: "flex", alignItems: "center", justifyContent: c.align === "right" ? "flex-end" : "center", textAlign: c.align } : {}),
                                            }}
                                        >
                                            {c.label}
                                            {c.sortKey && sort.sortBy === c.sortKey && (
                                                sort.sortOrder === "asc"
                                                    ? <ArrowUpwardIcon style={{ fontSize: 14 }} />
                                                    : <ArrowDownwardIcon style={{ fontSize: 14 }} />
                                            )}
                                        </div>
                                    ))}
                                </div>
                                {error || filtered.length === 0 ? (
                                    <div style={{ textAlign: "center", padding: "60px 0" }}>
                                        <Typography variant="h6" className="color-BCBCBC">
                                            No Records Found
                                        </Typography>
                                    </div>
                                ) : filtered.map((r) => {
                                    const isOpen = Boolean(expanded[r.id]);
                                    const fields = isOpen ? getExpandFields(r) : [];
                                    return (
                                        <div className="wrl-t-group" key={r.id}>
                                            <div className="wrl-t-row" style={{ gridTemplateColumns: gridTemplate }}>
                                                {visibleColumns.map((c) => (
                                                    <div
                                                        key={c.key}
                                                        style={c.align ? { display: "flex", alignItems: "center", justifyContent: c.align === "right" ? "flex-end" : "center", textAlign: c.align } : undefined}
                                                    >
                                                        {renderCell(c.key, r)}
                                                    </div>
                                                ))}
                                            </div>
                                            {isOpen && (() => {
                                                const tailLabels = ["Request Notes", "Hold Reason", "Closed Reason"];
                                                const gridFields = [
                                                    ...fields.filter((f) => !tailLabels.includes(f.label)),
                                                    ...tailLabels.map((l) => fields.find((f) => f.label === l)).filter(Boolean),
                                                ];
                                                return (
                                                    <div className="wrl-t-expand">
                                                        <div className="wrl-rd">
                                                            <div className="wrl-rd__body wrl-rd__body--notes">
                                                                <div className="wrl-t-expand__grid">
                                                                    {gridFields.map((field) => (
                                                                        <div key={field.label} className="wrl-detail">
                                                                            <p className="wrl-view__section">{field.label}</p>
                                                                            <div className="wrl-detail__value">{field.value}</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* Scroll pagination sentinel */}
                        <div ref={sentinelRef} style={{ height: 1 }} />
                        {loadingMore && (
                            <div style={{ margin: "25px auto", width: "100px", textAlign: "center" }}>
                                <Loader type="Puff" color="#9F7C50" height={50} width={50} />
                                <h4 className="color-p">Loading...</h4>
                            </div>
                        )}
                    </>
                )}

                <StyledMenu
                    id="request-actions-menu"
                    anchorEl={menu.anchorEl}
                    open={Boolean(menu.anchorEl)}
                    onClose={closeMenu}
                >
                    {ACTION_OPTIONS.filter((opt) => {
                        const s = statusClass(menu.request?.status);
                        if (opt.label === "Close Request") return s !== "closed";
                        if (opt.label === "Hold Request") return s !== "hold" && s !== "closed";
                        return true;
                    }).flatMap((opt) => [
                        opt.dividerBefore ? <Divider key={`${opt.label}-divider`} sx={{ my: 0.5 }} /> : null,
                        <MenuItem key={opt.label} onClick={() => handleAction(opt.label)} disableRipple>
                            {opt.icon}
                            {opt.label}
                        </MenuItem>,
                    ])}
                </StyledMenu>

                {/* Close Request popup */}
                <Dialog open={actionDialog.open} onClose={closeActionDialog} fullWidth maxWidth="sm">
                    {actionCfg && actionReq && (
                        <>
                            <DialogTitle>
                                {actionCfg.title}
                                <IconButton onClick={closeActionDialog} style={{ float: "right" }}>
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <div style={{ fontSize: "16px", lineHeight: 1.6 }}>
                                    Are you sure you want to <strong>{actionCfg.verb}</strong> the request{" "}
                                    "{actionReq.title || "-"}" ({actionReq.requestno || "-"})?
                                </div>
                                <div>
                                    <FormControl fullWidth style={{ margin: "20px 0px" }}>
                                        <TextField
                                            label={actionCfg.commentLabel}
                                            multiline
                                            maxRows={4}
                                            required
                                            value={actionComment}
                                            onChange={(e) => {
                                                setActionComment(e.target.value);
                                                if (actionError) setActionError("");
                                            }}
                                        />
                                        <FormHelperText className="error-o">{actionError}</FormHelperText>
                                    </FormControl>
                                </div>
                                <p style={{ display: "flex", alignItems: "center", fontSize: "14px", fontWeight: 500, lineHeight: 1.5 }}>
                                    <InfoIcon style={{ marginRight: "8px", fontSize: "22px", color: "rgba(0, 0, 0, 0.6)" }} />
                                    {actionCfg.info}
                                </p>
                            </DialogContent>
                            <DialogActions>
                                <Button color="primary" autoFocus onClick={closeActionDialog}>
                                    Cancel
                                </Button>
                                <Button color="primary" onClick={submitAction}>Ok</Button>
                            </DialogActions>
                        </>
                    )}
                </Dialog>
                {/* Delete Request alert */}
                <Dialog open={Boolean(deleteRequest)} onClose={() => setDeleteRequest(null)} maxWidth="sm" fullWidth>
                    <DialogTitle>
                        Delete
                        <IconButton
                            onClick={() => setDeleteRequest(null)}
                            style={{ float: "right" }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            {" "}
                            Are you sure you want to delete this request ({deleteRequest?.requestno || "-"})?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="primary"
                            onClick={() => setDeleteRequest(null)}
                        >
                            Cancel
                        </Button>
                        <Button color="primary" onClick={submitDelete}>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </div>
    );

    return <ContentWrapper contentView={contentView} />;
};

function mapStateToProps({ browseWatchesInfo }) {
    return { brandInfo: browseWatchesInfo.brandInfo };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ brandList }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchRequestList);
